import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import ReactPlayer from 'react-player/lazy'
import { Button } from 'react-bootstrap'
import imageClient1 from '../../../../public/assets/images/ecommerce-development-company/c1.png'
import imageClient2 from '../../../../public/assets/images/ecommerce-development-company/c3.png'
import imageClient3 from '../../../../public/assets/images/ecommerce-development-company/c2.png'

import playIcon from '../../../../public/assets/images/ecommerce-development-company/play.png'
import pauseIcon from '../../../../public/assets/images/ecommerce-development-company/pause.png'
import Image from 'next/image'

const VideoPlayer = ({ video, activeVideo, setActiveVideo }) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const handleVideoClick = () => {
    const videoElement = videoRef.current
    if (!videoElement) return

    if (isPlaying) {
      videoElement.pause()
      setActiveVideo(0)
    } else {
      videoElement.play()
      setActiveVideo(video.id)
    }

    setIsPlaying(!isPlaying)
  }

  useEffect(() => {
    if (videoRef === null) {
      return
    }

    if (video.id === activeVideo) {
      videoRef.current?.play()
      setIsPlaying(true)
    } else {
      videoRef.current?.pause()
      setIsPlaying(false)
    }
  }, [activeVideo])

  return (
    <div className={`${isPlaying ? 'playing' : 'paused'} testimonial-video`}>
      <div className="play-icon" />
      <div className="pause-icon" />

      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        playsInline
        ref={videoRef}
        onClick={handleVideoClick}
        width="100%"
        height="100%"
      >
        <source src={video.src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}
const TestimonialsSection = () => {
  const [activeVideo, setActiveVideo] = useState(0)

  const videos = [
    {
      id: 1,
      src: '/assets/video/client1.mp4',
      poster: 'assets/images/ecommerce-development-company/c1.png',
    },
    {
      id: 2,
      src: '/assets/video/client2.mp4',
      poster: 'assets/images/ecommerce-development-company/c2.png',
    },
    {
      id: 3,
      src: '/assets/video/client3.mp4',
      poster: 'assets/images/ecommerce-development-company/c3.png',
    },
  ]

  const testimonialsSettings = {
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 4000,
    // variableWidth: true,
    // adaptiveHeight: false,
    pauseOnHover: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    afterChange: () => {
      setActiveVideo(0)
    },
  }

  return (
    <section className="testimonials_section section_space dark_section">
      <div className="container">
        <div className="section_titles dark text-start">
          <p className="sub_title">Testimonials</p>
          <h2 className="title left_title">Your business is in good hands</h2>
        </div>
        <Slider {...testimonialsSettings} className="testimonials_slider">
          {videos.map((video) => (
            <div className="slide_item" key={video.id}>
              <VideoPlayer
                video={video}
                activeVideo={activeVideo}
                setActiveVideo={setActiveVideo}
              />
            </div>
          ))}{' '}
          <div className="slide_item">
            <div className="text_block_wrap">
              <div className="quote_icon">
                <svg
                  width="59"
                  height="40"
                  viewBox="0 0 59 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M45.9032 40C42.2442 40 39.195 38.7526 36.7556 36.2578C34.3717 33.7076 33.1797 30.0762 33.1797 25.3638C33.1797 21.0395 34.0113 17.2141 35.6745 13.8877C37.3377 10.5613 39.4168 7.73389 41.9116 5.40541C44.4064 3.07692 46.9289 1.27512 49.4791 0L53.8866 4.98961C52.5006 5.54401 50.9206 6.59737 49.1465 8.14969C47.4278 9.64657 45.9032 11.3929 44.5727 13.3888C43.2976 15.3292 42.6046 17.2973 42.4937 19.2931C42.9926 18.6279 43.852 18.0735 45.0716 17.6299C46.2913 17.1864 47.5664 16.9647 48.897 16.9647C51.3918 16.9647 53.6094 17.8794 55.5498 19.7089C57.5456 21.483 58.5436 24.0055 58.5436 27.2765C58.5436 31.1573 57.3239 34.262 54.8845 36.5904C52.5006 38.8635 49.5068 40 45.9032 40ZM12.8055 40C9.14648 40 6.09728 38.7526 3.65792 36.2578C1.27399 33.7076 0.0820312 30.0762 0.0820312 25.3638C0.0820312 21.0395 0.913632 17.2141 2.57683 13.8877C4.24004 10.5613 6.31904 7.73389 8.81384 5.40541C11.3086 3.07692 13.8312 1.27512 16.3814 0L20.7889 4.98961C19.4029 5.54401 17.8229 6.59737 16.0488 8.14969C14.3301 9.64657 12.8055 11.3929 11.475 13.3888C10.1998 15.3292 9.50684 17.2973 9.39596 19.2931C9.89492 18.6279 10.7542 18.0735 11.9739 17.6299C13.1936 17.1864 14.4687 16.9647 15.7993 16.9647C18.2941 16.9647 20.5117 17.8794 22.4521 19.7089C24.4479 21.483 25.4459 24.0055 25.4459 27.2765C25.4459 31.1573 24.2262 34.262 21.7868 36.5904C19.4029 38.8635 16.4091 40 12.8055 40Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="content_block d-flex justify-content-center align-items-center">
                <div className="text_quote">
                  <p>
                    &ldquo;Their ability to start quickly and hit the ground
                    running is outstanding. Internal stakeholders are quite
                    pleased with the value WebClues Infotech delivers.
                    They&apos;ve earned a reputation for on-time deliveries that
                    fulfill initial requirements. Their diverse skills and
                    ability to dive into new projects are also
                    noteworthy.&ldquo;
                  </p>
                </div>
              </div>
              <div className="clients_detail">
              <Image
                 width={80}
                    height={80} src="/assets/images/testimonial/Mike_Lanzone.jpg" alt="" />
                <div className="d-flex flex-column">
                  <h3 className="name mb-0">Mike Lanzone</h3>
                  <p className="proffession mb-0">CEO, Atlanta - USA</p>
                </div>
              </div>
            </div>
          </div>
          <div className="slide_item">
            <div className="text_block_wrap">
              <div className="quote_icon">
                <svg
                  width="59"
                  height="40"
                  viewBox="0 0 59 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M45.9032 40C42.2442 40 39.195 38.7526 36.7556 36.2578C34.3717 33.7076 33.1797 30.0762 33.1797 25.3638C33.1797 21.0395 34.0113 17.2141 35.6745 13.8877C37.3377 10.5613 39.4168 7.73389 41.9116 5.40541C44.4064 3.07692 46.9289 1.27512 49.4791 0L53.8866 4.98961C52.5006 5.54401 50.9206 6.59737 49.1465 8.14969C47.4278 9.64657 45.9032 11.3929 44.5727 13.3888C43.2976 15.3292 42.6046 17.2973 42.4937 19.2931C42.9926 18.6279 43.852 18.0735 45.0716 17.6299C46.2913 17.1864 47.5664 16.9647 48.897 16.9647C51.3918 16.9647 53.6094 17.8794 55.5498 19.7089C57.5456 21.483 58.5436 24.0055 58.5436 27.2765C58.5436 31.1573 57.3239 34.262 54.8845 36.5904C52.5006 38.8635 49.5068 40 45.9032 40ZM12.8055 40C9.14648 40 6.09728 38.7526 3.65792 36.2578C1.27399 33.7076 0.0820312 30.0762 0.0820312 25.3638C0.0820312 21.0395 0.913632 17.2141 2.57683 13.8877C4.24004 10.5613 6.31904 7.73389 8.81384 5.40541C11.3086 3.07692 13.8312 1.27512 16.3814 0L20.7889 4.98961C19.4029 5.54401 17.8229 6.59737 16.0488 8.14969C14.3301 9.64657 12.8055 11.3929 11.475 13.3888C10.1998 15.3292 9.50684 17.2973 9.39596 19.2931C9.89492 18.6279 10.7542 18.0735 11.9739 17.6299C13.1936 17.1864 14.4687 16.9647 15.7993 16.9647C18.2941 16.9647 20.5117 17.8794 22.4521 19.7089C24.4479 21.483 25.4459 24.0055 25.4459 27.2765C25.4459 31.1573 24.2262 34.262 21.7868 36.5904C19.4029 38.8635 16.4091 40 12.8055 40Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="content_block d-flex justify-content-center align-items-center">
                <div className="text_quote">
                  <p>
                    &ldquo;We were very pleased with their ability to turn our
                    idea into a reality. They have got aced designers and
                    developers who can boost customer engagement and bring on
                    board new revenue channels.&ldquo;
                  </p>
                </div>
              </div>
              <div className="clients_detail">
              <Image
                 width={80}
                    height={80}
                  src="/assets/images/testimonial/Michael_Terrance_Houlder.png"
                  alt=""
                />
                <div className="d-flex flex-column">
                  <h3 className="name mb-0">Michael</h3>
                  <p className="proffession mb-0">CEO, Canada</p>
                </div>
              </div>
            </div>
          </div>
          <div className="slide_item">
            <div className="text_block_wrap">
              <div className="quote_icon">
                <svg
                  width="59"
                  height="40"
                  viewBox="0 0 59 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M45.9032 40C42.2442 40 39.195 38.7526 36.7556 36.2578C34.3717 33.7076 33.1797 30.0762 33.1797 25.3638C33.1797 21.0395 34.0113 17.2141 35.6745 13.8877C37.3377 10.5613 39.4168 7.73389 41.9116 5.40541C44.4064 3.07692 46.9289 1.27512 49.4791 0L53.8866 4.98961C52.5006 5.54401 50.9206 6.59737 49.1465 8.14969C47.4278 9.64657 45.9032 11.3929 44.5727 13.3888C43.2976 15.3292 42.6046 17.2973 42.4937 19.2931C42.9926 18.6279 43.852 18.0735 45.0716 17.6299C46.2913 17.1864 47.5664 16.9647 48.897 16.9647C51.3918 16.9647 53.6094 17.8794 55.5498 19.7089C57.5456 21.483 58.5436 24.0055 58.5436 27.2765C58.5436 31.1573 57.3239 34.262 54.8845 36.5904C52.5006 38.8635 49.5068 40 45.9032 40ZM12.8055 40C9.14648 40 6.09728 38.7526 3.65792 36.2578C1.27399 33.7076 0.0820312 30.0762 0.0820312 25.3638C0.0820312 21.0395 0.913632 17.2141 2.57683 13.8877C4.24004 10.5613 6.31904 7.73389 8.81384 5.40541C11.3086 3.07692 13.8312 1.27512 16.3814 0L20.7889 4.98961C19.4029 5.54401 17.8229 6.59737 16.0488 8.14969C14.3301 9.64657 12.8055 11.3929 11.475 13.3888C10.1998 15.3292 9.50684 17.2973 9.39596 19.2931C9.89492 18.6279 10.7542 18.0735 11.9739 17.6299C13.1936 17.1864 14.4687 16.9647 15.7993 16.9647C18.2941 16.9647 20.5117 17.8794 22.4521 19.7089C24.4479 21.483 25.4459 24.0055 25.4459 27.2765C25.4459 31.1573 24.2262 34.262 21.7868 36.5904C19.4029 38.8635 16.4091 40 12.8055 40Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="content_block d-flex justify-content-center align-items-center">
                <div className="text_quote">
                  <p>
                    &ldquo;The team&apos;s responsive communication, industry
                    knowledge, and receptive approach to the partnership make
                    for a positive and productive collaboration. They always
                    come up with valuable insights.&ldquo;
                  </p>
                </div>
              </div>
              <div className="clients_detail">
              <Image
                 width={80}
                    height={80}
                  src="/assets/images/testimonial/stephen_belcher.jpg"
                  alt=""
                />
                <div className="d-flex flex-column">
                  <h3 className="name mb-0">Stephen</h3>
                  <p className="proffession mb-0">
                    Director of IT Solutions, Nashville - USA
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
      <div id="contactUS" />
    </section>
  )
}

export default TestimonialsSection
